import { ElementStateBitmask, type ElementState } from "./types.ts";

export const createElementStateId = (id: string | number) => `node-${id.toString()}` as const;

/** CSS selector matching any node-state element. */
export const NODE_ELEMENT_ID_SELECTOR = '[id^="node-"]';

/** Returns the DOM element for a node by its id, or null if not in the DOM. */
export const getNodeElement = (id: string | number): HTMLElement | null =>
  document.getElementById(createElementStateId(id));

/** Extracts the numeric node id from an element with a `node-${id}` id, or undefined. */
export const parseNodeElementId = (elementId: string): number | undefined => {
  const match = elementId.match(/^node-(\d+)$/);
  return match ? Number(match[1]) : undefined;
};

export const getElementStateKeyOfEnum = (elementStateBitmask: ElementStateBitmask) =>
  ElementStateBitmask[elementStateBitmask] as ElementState;

export const getExistingRefKey = (nodeId: number, nodeReferences?: Record<string, number>): string | null => {
  return Object.entries(nodeReferences ?? {}).find(([_, refId]) => refId === nodeId)?.[0] ?? null;
};

// Generate random 11-character base64url string
// 11 base64 characters = 11 * 6 bits = 66 bits = 8 bytes + 2 padding bits
export const createNodeRefKey = () => {
  return base64UrlSafe(crypto.getRandomValues(new Uint8Array(8)));
};

const base64UrlSafe = (bytes: Uint8Array) => {
  // Not a great version of base64url, but good enough for our purposes
  // When more available, switch to https://github.com/tc39/proposal-arraybuffer-base64
  // return bytes.toBase64({ alphabet: "base64url", omitPadding: true })
  return btoa(String.fromCharCode(...bytes))
    .replace(/=+$/, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");
};
